import React from 'react'

import { config } from '../Config/config'
import cariobatService from '../Service/cariobatService'


export default class listObat extends React.Component {

    constructor() {
        super()
        this.state = {
            List: [],
            showModalCari: false,
            count: 0,
            TotalProduct: 0,
            EstimatePrice: 0,
            displayButton: "",
            displayTambah: "none",
            filter: {


            }
        }
    }

    gantiButton = () => {
        console.log("hehe")
        this.setState({
            displayButton: 'none',
            displayTambah: ''
        })
    }



    render() {
        const { displayButton, displayTambah, TotalProduct } = this.state

        return (
            <div class="row">
                <div class="col" style={{ display: `${displayButton}` }}>
                    <button class="btn btn-primary" onClick={this.gantiButton} >Tambah ke Keranjang</button>
                </div>
                <div class="col ml-5" style={{ display: `${displayTambah}` }}>
                    <div class="row">
                        <button class="btn btn-primary mr-3">+</button>
                        <h5 class="mr-3">{TotalProduct}</h5>
                        <button class="btn btn-primary">+</button>
                    </div>
                </div>
                <div class="col">
                    <button class="btn btn-outline-primary float-right">Detail</button>
                </div>
            </div>
        )
    }
}